export const initUmami = () => {
  umTrackView();
};

export default defineNuxtPlugin(() => {
  window.addEventListener('pointerdown', initUmami, { once: true });
  window.addEventListener('keydown', initUmami, { once: true });
  window.addEventListener('scroll', initUmami, {
    once: true,
    passive: true,
    capture: true,
  });
});
